import * as React from 'react';
import {MainBanner} from "../components/banners/MainBanner";
import {Program} from "./Visitors/Program";
import {Map} from '../components/Map';
import {GalleryConference} from "./Main/GalleryConference";
import {Brands} from "../components/Brands";

export class Visitors extends React.Component<any, any> {
    render() {
        return (
            <div className="visitors">
                <MainBanner compact />
                <Program />
                <div className="run-a-game">
                    <div className="bn">
                        Не пропусти розыгрыш подарков
                        по номеру пригласительного билета!
                    </div>
                </div>
                <Brands />
                <GalleryConference />
                <div className="row">
                    <Map />
                </div>
            </div>
        )
    }
}



/** WEBPACK FOOTER **
 ** ./src/route/Visitors.tsx
 **/